export default __webpack_public_path__ + "static/media/novice-guide-en.cf27205f.png";